module.exports = __webpack_public_path__ + "assets/img/xjtwo.fc94af98.png";